import { CustomsPingMappers } from './ping';
import { DnsMappers } from './dns';

export class CustomsMappers {
  public static Ping = CustomsPingMappers;
  public static Dns = DnsMappers;
}
